import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { StorageService } from '../../../shared/security/StorageService';
import { ChangeEmployerService } from '../../../broker/change-employer/change-employer.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { IndividualRenewalService } from '../../individual-renewal/individual-renewal.service';
import { EntityRenewalService } from '../entity-renewal.service';
import { PaymentService } from '../../../shared/payment/payment.service';
import { Router } from '@angular/router';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { StartPaymentRequestModel } from '../../../model/startPaymentRequestModel';
import { MessageModel, ContentPageModel } from '../../../model/models';
import { Subscription } from 'rxjs';
import { SubmitIndividualCorporationStatusResponseModel } from '../../../model/submitIndividualCorporationStatusResponseModel';
import { SubmitQuestionnaireAnswersResponseModel } from '../../../model/submitQuestionnaireAnswersResponseModel';
import { SelectInactiveOfficesToRenewResponseModel } from '../../../model/selectInactiveOfficesToRenewResponseModel';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { CompleteFunctionRequestModel } from '../../../model/completeFunctionRequestModel';
import { CompleteFunctionResponseModel } from '../../../model/completeFunctionResponseModel';
import { CompleteFunctionService } from '../../../shared/utils/complete-function.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-renewal-receipt',
  templateUrl: './renewal-receipt.component.html',
  styleUrls: ['./renewal-receipt.component.css']
})
export class RenewalReceiptComponent implements OnInit, OnDestroy {
  
  title :string ="Renew Entity License";
  startFunction: StartFunctionResponseModel = {};

  workflow: WorkflowModel = new WorkflowModel();
  startPaymentRequest: StartPaymentRequestModel = new StartPaymentRequestModel();

  userMessages: Array<MessageModel> = [];

  notifyIndividualCorporationStatusResponseSubscription = new Subscription();
  notifySubmitQuestionnaireAnswersSubscription: Subscription = new Subscription();
  notifySubmitEntityQuestionnaireAnswersSubscription: Subscription = new Subscription();
  notifySelectInactiveOfficesToRenewSubscription: Subscription = new Subscription();
  notifyEntityQuestionListSubscription: Subscription = new Subscription();
  notifyIndividualQuestionListSubscription: Subscription = new Subscription();
  notifycompleteFunctionRespSubscription : Subscription = new Subscription();

  individualCorporationStatusResponse: SubmitIndividualCorporationStatusResponseModel = null;
  submitIndividualQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = null;
  submitEntityQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = null;
  selectInactiveOfficesToRenewResponseModel: SelectInactiveOfficesToRenewResponseModel = null;

  entityRenewalQuestions: Array<QuestionnaireQuestionModel> = [];
  individualRenewalQuestions: Array<QuestionnaireQuestionModel> = [];
  completeFunctionRequest: CompleteFunctionRequestModel;
  completeFunctionResponse: CompleteFunctionResponseModel = null;
  public now: Date = new Date();
  receiptInfo : ContentPageModel = {};

  constructor(private storage: StorageService,
    private changeEmployerService: ChangeEmployerService,
    private currentPageWatcher: CurrentPageWatcherService,
    private individualRenewalService: IndividualRenewalService,
    private entityRenewalService: EntityRenewalService,
    private completeFunctionService : CompleteFunctionService,
    private router: Router,
    private paymentService : PaymentService,
    private startFunctionService : StartFunctionService) { 

      this.startFunction = this.storage.getStartFunctionData();

    //update workflow data
      this.workflow = this.startFunction.Workflow;

      //if pay step is not yet checked, then notify step in progress
      if (this.startFunction.Workflow.Steps.filter(el => el.checked == false).length == 2) {
        //check pay step
        this.startFunctionService.getNotifyStepInProgress().emit(true);
      }

    this.notifyIndividualCorporationStatusResponseSubscription = this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().subscribe(
      (data: SubmitIndividualCorporationStatusResponseModel) => {
        this.individualCorporationStatusResponse = data;
      }
    );

    this.notifySubmitQuestionnaireAnswersSubscription = this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().subscribe(submitQuestionnaireAnswersResp => {
      this.submitIndividualQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;
    });

    this.notifySubmitEntityQuestionnaireAnswersSubscription = this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().subscribe(submitQuestionnaireAnswersResp => {
      this.submitEntityQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;
    });

    this.notifySelectInactiveOfficesToRenewSubscription = this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().subscribe(
      selectInactiveOfficesData => {
        this.selectInactiveOfficesToRenewResponseModel = selectInactiveOfficesData;
      });

      this.notifyEntityQuestionListSubscription = this.entityRenewalService.getNotifyQuestionList().subscribe(questionListData => {
        this.entityRenewalQuestions = questionListData;
      });

      this.notifyIndividualQuestionListSubscription = this.individualRenewalService.getNotifyIndividualQuestionList().subscribe(questionListData => {
        this.individualRenewalQuestions = questionListData;
      });

      this.notifycompleteFunctionRespSubscription = this.completeFunctionService.getNotifyCompleteFunctionResponse().subscribe(data => {
        this.completeFunctionResponse = data;
      });
  }

  ngOnInit() {

      //init data from localstorage if receipt page is returned from scs (no emitter)
    if(this.entityRenewalQuestions == null|| this.entityRenewalQuestions.length==0){
      this.entityRenewalQuestions = this.entityRenewalService.getQuestionListData();
    }
    if(this.individualCorporationStatusResponse == null){
      this.individualCorporationStatusResponse = this.individualRenewalService.getIndividualCorporationStatusData();
    }
    if(this.individualRenewalQuestions == null || this.individualRenewalQuestions.length==0){
      this.individualRenewalQuestions = this.individualRenewalService.getIndividualRenewalQuestionsData();
    }
    if(this.selectInactiveOfficesToRenewResponseModel == null){
      this.selectInactiveOfficesToRenewResponseModel = this.entityRenewalService.getSelectInactiveOfficesToRenewResponseData();
    }
    if(this.submitEntityQuestionnaireAnswersResponseModel == null){
      this.submitEntityQuestionnaireAnswersResponseModel = this.entityRenewalService.getSubmitQuestionnaireAnswersResponseData();
    }
    if(this.submitIndividualQuestionnaireAnswersResponseModel == null){
      this.submitIndividualQuestionnaireAnswersResponseModel = this.individualRenewalService.getSubmitIndividualQuestionnaireAnswersData();
    }
  
    // if(this.submitEntityQuestionnaireAnswersResponseModel!=null){
    //   this.workflow = this.submitEntityQuestionnaireAnswersResponseModel.Workflow;
    // }

    // if(this.submitEntityQuestionnaireAnswersResponseModel==null &&  this.selectInactiveOfficesToRenewResponseModel!=null){
    //   this.workflow = this.selectInactiveOfficesToRenewResponseModel.Workflow;
    // }

    // if(this.submitEntityQuestionnaireAnswersResponseModel== null  && this.selectInactiveOfficesToRenewResponseModel== null && this.individualCorporationStatusResponse != null){
    //   this.workflow = this.individualCorporationStatusResponse.Workflow;
    // }

    // if(this.submitEntityQuestionnaireAnswersResponseModel == null && this.selectInactiveOfficesToRenewResponseModel == null && this.individualCorporationStatusResponse == null && this.submitIndividualQuestionnaireAnswersResponseModel != null){
    //   this.workflow = this.submitIndividualQuestionnaireAnswersResponseModel.Workflow;
    // }
    
    // if(this.submitEntityQuestionnaireAnswersResponseModel == null && this.selectInactiveOfficesToRenewResponseModel == null && this.individualCorporationStatusResponse == null && this.submitIndividualQuestionnaireAnswersResponseModel == null) {
    //   this.workflow = this.startFunction.Workflow;
    // }


    this.title= this.workflow.WorkflowDisplayName;
    this.currentPageWatcher.pageChanged().emit(this.title);
    if (this.completeFunctionResponse == null) { //test if payment step exist 
      this.paymentService.getPaymentReceipt(this.workflow.WorkflowID).subscribe(response => {
        console.log("get receipt response : ", response);
        this.receiptInfo = response;
      
      });
    }
  }

  goBackHome() {
    this.router.navigate(['/home']);
  }

  ngOnDestroy(): void {
    this.entityRenewalService.clearQuestionListData();
    this.entityRenewalService.clearSelectInactiveOfficesToRenewResponseData();
    this.entityRenewalService.clearSubmitQuestionnaireAnswersResponseData()
    this.individualRenewalService.cleartIndividualCorporationStatusData();
    this.individualRenewalService.clearIndividualRenewalQuestionsData();
    this.individualRenewalService.clearSubmitIndividualQuestionnaireAnswersData();
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
  }
  
  printPage(){
    window.print();
  }
// back browser button
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {

    if (this.completeFunctionResponse == null) { //test if payment step exist 
      //navigate to payment step
      this.router.navigate(["/renewalPay"]).then(() => {
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
        this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
        this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().emit(this.submitEntityQuestionnaireAnswersResponseModel);
        this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
        this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalQuestions);
        this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);

      })
    }
    else{
      // navigate to review page
      this.router.navigate(["/reviewEntityRenewal"]).then(()=>{
        this.startFunctionService.getNotifyStepInProgress().emit(false);
        this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
          this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);
          this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().emit(this.submitEntityQuestionnaireAnswersResponseModel);
          this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
          this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalQuestions);
          this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
  
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/renewal/entity-renewal/renewal-receipt/renewal-receipt.component.ts